"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _layouts = _interopRequireDefault(require("../layouts"));
var _default = _interopRequireDefault(require("../layouts/default"));
var _cccisdFooter = _interopRequireDefault(require("cccisd-footer"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AppHeader = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/deployment\/AppHeader\/index\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return null;
}();
var AppFooter = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/deployment\/AppFooter\/index\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return null;
}();
var PlayerLayout = /*#__PURE__*/function (_React$Component) {
  _inherits(PlayerLayout, _React$Component);
  var _super = _createSuper(PlayerLayout);
  function PlayerLayout() {
    var _this;
    _classCallCheck(this, PlayerLayout);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      /**
       * Course Wrapper needs to toggle background color depending on tab
       * Usually, first tab is Description with no background, so this
       * prevents the flicker effect of showing bg initially and taking it away
       */
      isShowingLayoutBgColor: _this.props.navigation && _this.props.navigation.startsWith('courseWrapper') ? false : true
    });
    _defineProperty(_assertThisInitialized(_this), "setIsShowingLayoutBgColor", function (bool) {
      if (_this.state.isShowingLayoutBgColor !== bool) {
        _this.setState({
          isShowingLayoutBgColor: bool
        });
      }
    });
    return _this;
  }
  _createClass(PlayerLayout, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        showHeader = _this$props.showHeader,
        showFooter = _this$props.showFooter,
        frameHandle = _this$props.frameHandle,
        settings = _this$props.settings;
      var currentLayout = _layouts["default"].find(function (item) {
        return item.handle === frameHandle;
      }) || _default["default"];
      var LayoutComponent = currentLayout.component;

      // need to pass setIsShowingBackground through children to the mediator
      var children = _react["default"].Children.map(this.props.children, function (child) {
        if ( /*#__PURE__*/_react["default"].isValidElement(child)) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            setIsShowingLayoutBgColor: _this2.setIsShowingLayoutBgColor,
            currentLayout: _objectSpread(_objectSpread({}, currentLayout), {}, {
              settings: settings
            })
          });
        }
        return child;
      });
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.DefaultPlayerSettingsContext.Provider, {
        value: currentLayout.flowPlayerSettings
      }, /*#__PURE__*/_react["default"].createElement(LayoutComponent, {
        showHeader: showHeader,
        showFooter: showFooter,
        header: AppHeader && /*#__PURE__*/_react["default"].createElement(AppHeader, null),
        footer: AppFooter && /*#__PURE__*/_react["default"].createElement(AppFooter, null) || /*#__PURE__*/_react["default"].createElement(_cccisdFooter["default"], null),
        settings: settings,
        isShowingLayoutBgColor: this.state.isShowingLayoutBgColor
      }, children));
    }
  }]);
  return PlayerLayout;
}(_react["default"].Component);
exports["default"] = PlayerLayout;
_defineProperty(PlayerLayout, "propTypes", {
  /** Should we show the header? */
  showHeader: _propTypes["default"].bool,
  /** Should we show the header? */
  showFooter: _propTypes["default"].bool,
  /** The handle of the background to use */
  frameHandle: _propTypes["default"].string,
  settings: _propTypes["default"].object,
  navigation: _propTypes["default"].string,
  children: _propTypes["default"].node
});